module.exports = __webpack_public_path__ + "img/qualityOrange.27dc5a22.png";